module.exports = __webpack_public_path__ + "static/media/logo_kominfo_white.e3b7c12d.png";